/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Points configuration for league standings
 * @export
 * @interface LeaguePointsConfig
 */
export interface LeaguePointsConfig {
    /**
     * 
     * @type {number}
     * @memberof LeaguePointsConfig
     */
    pointsPerWin?: number;
    /**
     * 
     * @type {number}
     * @memberof LeaguePointsConfig
     */
    pointsPerDraw?: number;
    /**
     * 
     * @type {number}
     * @memberof LeaguePointsConfig
     */
    pointsPerLoss?: number;
    /**
     * 
     * @type {number}
     * @memberof LeaguePointsConfig
     */
    bonusPointsPerGoal?: number;
    /**
     * 
     * @type {number}
     * @memberof LeaguePointsConfig
     */
    cleanSheetBonus?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof LeaguePointsConfig
     */
    tiebreakers?: Array<string>;
}

/**
 * Check if a given object implements the LeaguePointsConfig interface.
 */
export function instanceOfLeaguePointsConfig(value: object): value is LeaguePointsConfig {
    return true;
}

export function LeaguePointsConfigFromJSON(json: any): LeaguePointsConfig {
    return LeaguePointsConfigFromJSONTyped(json, false);
}

export function LeaguePointsConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaguePointsConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'pointsPerWin': json['pointsPerWin'] == null ? undefined : json['pointsPerWin'],
        'pointsPerDraw': json['pointsPerDraw'] == null ? undefined : json['pointsPerDraw'],
        'pointsPerLoss': json['pointsPerLoss'] == null ? undefined : json['pointsPerLoss'],
        'bonusPointsPerGoal': json['bonusPointsPerGoal'] == null ? undefined : json['bonusPointsPerGoal'],
        'cleanSheetBonus': json['cleanSheetBonus'] == null ? undefined : json['cleanSheetBonus'],
        'tiebreakers': json['tiebreakers'] == null ? undefined : json['tiebreakers'],
    };
}

export function LeaguePointsConfigToJSON(json: any): LeaguePointsConfig {
    return LeaguePointsConfigToJSONTyped(json, false);
}

export function LeaguePointsConfigToJSONTyped(value?: LeaguePointsConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pointsPerWin': value['pointsPerWin'],
        'pointsPerDraw': value['pointsPerDraw'],
        'pointsPerLoss': value['pointsPerLoss'],
        'bonusPointsPerGoal': value['bonusPointsPerGoal'],
        'cleanSheetBonus': value['cleanSheetBonus'],
        'tiebreakers': value['tiebreakers'],
    };
}

